import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { CommonHttpService } from '../../commonHttp.service';
import { LoaderService } from '../../../_shared/services/loader.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-issues',
  templateUrl: './issues.component.html',
  styleUrls: ['./issues.component.css']
})
export class IssuesComponent implements OnInit {
	paramsId: number
  baseUrl: any = environment.apiUrl;
  issueDetails: any = {};
  issue: any = {};
  customerId: any;
  closeResult: string;
  
  constructor(private service: CommonHttpService, private router: Router, private route: ActivatedRoute, private loaderService: LoaderService, private modalService: NgbModal) { }

  ngOnInit() {
    window.scrollTo(0,0);
    this.customerId = localStorage.getItem('customerId');
  	this.route.params.subscribe(params => {
      this.paramsId = params['id'];
    });
    setTimeout(() => {
      this.loadData()
    },1);
  }

  loadData() {
    this.loaderService.display(true);
    this.service.get(this.baseUrl + 'IssueAPI/GetIssueDetailsByOrderId/' + this.paramsId)
      .subscribe(
        data => {
          console.log(data)
          this.issueDetails = data[0];
          this.loaderService.display(false);
        },
        (error) => {
          this.loaderService.display(false);
        })
  }

  submitIssue(){
    let sendData = { IssueDetails:
                    {
                      IssueId: 0,
                      EorderMasterId: this.paramsId,
                      CustomerId: this.customerId,
                      IssueDescription: this.issue.comment,
                      IsActive:1,
                      IsDeleted:0,
                      CreatedDate: new Date(),
                      IssueStatus:[{
                        IssueId:0,
                        IssueStatus1: 'new',
                        IsActive:1,
                        IsDeleted:0,
                        CreatedDate: new Date()
                      }]
                    }
                  }
    this.service.create(this.baseUrl + 'IssueAPI/CreateIssue', sendData)
      .subscribe(
      data => {
        console.log(data)
        this.loadData();
      },
      (error) => {
      });

  }

  EditIssueModal(editIssueContent: any) {
    this.modalService.open(editIssueContent).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  editIssue(){
    let sendData = {
                    IssueDetails:
                      {
                        issueStatusId: this.issueDetails.issueStatusId,
                        issueStatus1: "new",
                        issueId: this.issueDetails.issueId,
                        issueDescription: this.issue.comment
                      }
                    }
    this.service.update(this.baseUrl + 'IssueAPI/EditIssue/' + this.issueDetails.issueId, sendData)
      .subscribe(
      data => {
        (<HTMLElement>document.getElementById("closeEditIssue")).click();
        console.log(data)
        this.loadData();
      },
      (error) => {
      });

  }

}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/orders/issues/issues.component.ts